import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { InsiderTileBadgeRenderer } from "@faire/retailer-visitor-shared/components/InsiderBadge/InsiderTileBadgeRenderer";
import { productTileBrandLinkPropsAdapter } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/BrandInfo/Links/SearchProductTileBrandLinkProps";
import { Column } from "@faire/web--source/slate/Layout";
import React from "react";
import { BrandMinimum } from "./components/BrandMinimum";
import { BrandNameText } from "./components/BrandNameText";
import { BrandPromoText } from "./components/BrandPromoText";
import { MaybeBrandLocationAndReviews } from "./components/MaybeBrandLocationAndReviews";
import { SearchProductTileBrandLink } from "./Links/SearchProductTileBrandLink";
import { BrandInfoProductLink } from "./Links/BrandInfoProductLink";
export var BrandInfo = function(param) {
    var data = param.data;
    var brandLinkProps = productTileBrandLinkPropsAdapter(data);
    if (!data) {
        return null;
    }
    var _data_brandToken, _data_brandName, _data_isLoggedInRetailer, _data_isLoggedInRetailer1;
    return /*#__PURE__*/ _jsxs(Column, {
        gap: {
            mobileAndAbove: 2,
            tabletAndAbove: 4
        },
        children: [
            /*#__PURE__*/ _jsx(SearchProductTileBrandLink, {
                data: brandLinkProps,
                children: /*#__PURE__*/ _jsx(BrandNameText, {
                    brandToken: (_data_brandToken = data.brandToken) !== null && _data_brandToken !== void 0 ? _data_brandToken : "",
                    brandName: (_data_brandName = data.brandName) !== null && _data_brandName !== void 0 ? _data_brandName : "",
                    isLoaded: true,
                    brandIcon: data.brandIcon
                })
            }),
            /*#__PURE__*/ _jsxs(BrandInfoProductLink, {
                dataTestId: data.dataTestId,
                children: [
                    /*#__PURE__*/ _jsx(BrandMinimum, {
                        minimumOrderAmount: data.minimumOrderAmount,
                        avgBrandReviewRating: data.avgBrandReviewRating,
                        isLoggedInRetailer: (_data_isLoggedInRetailer = data.isLoggedInRetailer) !== null && _data_isLoggedInRetailer !== void 0 ? _data_isLoggedInRetailer : false
                    }),
                    data.insiderBadgeProps.insiderLabelText ? /*#__PURE__*/ _jsx(InsiderTileBadgeRenderer, _object_spread({}, data.insiderBadgeProps)) : null,
                    /*#__PURE__*/ _jsx(BrandPromoText, {
                        promoText: data.brandPromoText,
                        isHighlightedPromo: data.isHighlightedProductForPromotionalEvent
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(MaybeBrandLocationAndReviews, {
                isLoggedInRetailer: (_data_isLoggedInRetailer1 = data.isLoggedInRetailer) !== null && _data_isLoggedInRetailer1 !== void 0 ? _data_isLoggedInRetailer1 : false,
                flagCountryCode: data.flagCountryCode,
                shipsFromMessage: data.shipsFromMessage,
                avgBrandReviewRating: data.avgBrandReviewRating,
                brandReviewCount: data.brandReviewCount
            })
        ]
    });
};
